import { CREATE_PASSWORD_RECOVERY_TOKEN } from '../Types';

export const createPasswordRecoveryToken = (email) => {
  return (dispatch) => {
    const action = {
      type: CREATE_PASSWORD_RECOVERY_TOKEN,
      request: async (apiClient) => {
        return await apiClient.user.createPasswordRecoveryToken(
          encodeURIComponent(email.toLowerCase())
        );
      },
    };

    dispatch(action);
  };
};

export default createPasswordRecoveryToken;
